import "Data/ServerSource";
/** @namespace GIS.Data */
NS("Cadastre.Data");

/**
 * GIS.Data.LayerFeatures source
 * @class
 * @extends Data.ServerSource
 */
Cadastre.Data.Cadnums = Class(Data.ServerSource, /** @lends GIS.Data.Cadastre.prototype */ {
    url: "Cadastre/Web/Cadnums/",

    fields: [
        { name: "id", title: "id" }, // string
        { name: "cadnum", title: "Кадастровый номер" }, // streing
        { name: "geog", title: "geog" }, // json

		{ name: "datecreate", title: "Дата создания" },
		{ name: "dateins", title: "Дата добавления" },
		{ name: "datechange", title: "Дата изменения" },
		{ name: "typeid", title: "typeid" },
		{ name: "stateid", title: "stateid" },
		{ name: "categoryid", title: "categoryid" },
		{ name: "permitteduse", title: "permitteduse" },
		{ name: "permitteduserrid", title: "permitteduserrid" },
		{ name: "permittedusemeid", title: "permittedusemeid" },
		{ name: "shapeleng", title: "shapeleng" },
		{ name: "shapearea", title: "shapearea" },
		{ name: "dateregistre", title: "dateregistre" },
		{ name: "docarea", title: "docarea" },
		{ name: "cadastreprice", title: "cadastreprice" },
		{ name: "docaddress", title: "docaddress" }
    ],

});
